import axios from "axios";
import { FileAudit } from "../models/FileAudit";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

class FileAuditUploadService {
  static async authorize(): Promise<{ authorizationUrl: string }> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/DropboxUpload/authorize`
      );
      return response.data;
    } catch (error) {
      console.error("Authorization failed:", error);
      throw error; // Re-lanza el error para que el componente lo maneje
    }
  }

  static async getFiles(auditId: number): Promise<FileAudit[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/filesaudit/${auditId}`
    );
    return response.data;
  }

  static async getFilesQuestion(auditQuestionId: number): Promise<FileAudit[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/filesauditquestion/${auditQuestionId}`
    );
    return response.data;
  }

  static async getFilesAnswer(
    auditId: number,
    auditQuestionId: number
  ): Promise<FileAudit[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/filesauditanswer/${auditId}/${auditQuestionId}`
    );
    return response.data;
  }

  static async uploadFiles(
    auditId: number,
    files: FileList
  ): Promise<FileAudit[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/uploadaudit/${auditId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async uploadFilesQuestion(
    auditQuestionId: number,
    files: FileList
  ): Promise<FileAudit[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/uploadauditq/${auditQuestionId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async uploadFilesAnswer(
    auditId: number,
    auditQuestionId: number,
    files: FileList
  ): Promise<FileAudit[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/uploadaudita/${auditId}/${auditQuestionId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async deleteFile(fileId: number): Promise<void> {
    await axios.post(`${API_BASE_URL}/DropboxUpload/fileaudit/${fileId}`);
  }
}

export default FileAuditUploadService;
